export default __webpack_public_path__ + "static/media/frown.43b8675b.svg";